export const bookingRecommendationSelector = state => state.bookingRecommendation.get('bookingRecommendation');
export const bookingRecommendationImagesSelector = state => state.bookingRecommendation.get('images');
export const bookingRecommendationIsLoadingSelector = state => state.bookingRecommendation.get('isLoading');
